import { APP_PERMISSIONS } from '@exam-center/permission';
import { Button, type ButtonProps } from '@shared/components';
import { WithPermission } from '@shared/permissions';

export default function ProctorRequestDeletionButton(props: ButtonProps) {
  const { onClick, disabled } = props;

  return (
    <WithPermission requiredPermission={APP_PERMISSIONS.PROCTOR_MANAGEMENT.PROCTOR_REQUEST.DELETE}>
      <Button size='large' color='error' onClick={onClick} disabled={disabled}>
        ลบแบบร่าง
      </Button>
    </WithPermission>
  );
}
